/**
 * Anti-spam utilities for form submissions
 *
 * - Honeypot field: hidden input that bots fill but humans don't
 * - Timing: records when form was loaded, rejects too-fast submissions
 */

/**
 * Inject a hidden honeypot field into the form.
 * Bots tend to fill all visible fields; this catches them.
 */
export function injectHoneypot(form: HTMLFormElement): void {
  const wrapper = document.createElement("div");
  // Hide with CSS and aria — invisible to humans, visible to bots
  wrapper.setAttribute(
    "style",
    "position:absolute;left:-9999px;top:-9999px;height:0;width:0;overflow:hidden;",
  );
  wrapper.setAttribute("aria-hidden", "true");

  const input = document.createElement("input");
  input.type = "text";
  input.name = "_hp";
  input.tabIndex = -1;
  input.autocomplete = "off";

  wrapper.appendChild(input);
  form.appendChild(wrapper);
}

/**
 * Get the form load timestamp for timing-based anti-spam.
 * Stored as a data attribute on the form element.
 */
export function getFormLoadTimestamp(form: HTMLFormElement): number {
  const ts = form.dataset.sfTs;
  return ts ? parseInt(ts, 10) : Date.now();
}

/**
 * Record the form load timestamp on the form element.
 */
export function setFormLoadTimestamp(form: HTMLFormElement): void {
  form.dataset.sfTs = String(Date.now());
}
